import { render } from "./zj-main.vue?vue&type=template&id=1a4f484d"
const script = {}

import exportComponent from "/var/jenkins_home/workspace/kj-wx-web-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__